import { configureAccountStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
import ContactUs from './ContactUs';
const store = configureAccountStore();
const ClientServiceContactUs = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(ContactUs, Object.assign({}, props))));
};
export default ClientServiceContactUs;
